import { GET_STARTED_PATH } from 'constants/path';

import type en from './__translations__/en.json';

export type GetStartedScreen = {
  analyticsEventName: string;
  cardMaw?: number;
  path: string;
  screenKey: keyof (typeof en)['Screens'];
  showFooter?: boolean;
};

export const GET_STARTED_SCREENS: GetStartedScreen[] = [
  {
    analyticsEventName: 'view_get_started_contact_info',
    path: 'contact-info',
    screenKey: 'contactInfo',
    showFooter: true,
  },
  {
    analyticsEventName: 'view_get_started_business_details',
    cardMaw: 800,
    path: 'business-details',
    screenKey: 'businessDetails',
    showFooter: false,
  },
];

export const FIRST_GET_STARTED_SCREEN = GET_STARTED_SCREENS[0];

export const getStartedScreenPath = (path: string) => `${GET_STARTED_PATH}/${path}`;
